import { render, staticRenderFns } from "./input-toggle_button.vue?vue&type=template&id=3481f154&lang=pug&"
import script from "./input-toggle_button.vue?vue&type=script&lang=js&"
export * from "./input-toggle_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports